<template>
    <div>
        <div class="simple__block">

            <div class="order__block_info">
                <template v-if="['sent'].includes(ordertype)">
                    <p>
                        <label>{{ formatText(get_translation_constant('text_tracking_number_full')) }}:</label> <a
                        href="javascript:void(0)" class="order__traking_number">{{ parcel.track_code }}</a><span
                        class="copy__traking_number"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                          xmlns="http://www.w3.org/2000/svg"><path
                        d="M5.89 18h6.18c1.25 0 1.9-.67 1.9-1.96V15h1.12c1.26 0 1.91-.67 1.91-1.98V7.45c0-.79-.16-1.3-.62-1.78l-2.89-3.03A2.1 2.1 0 0011.86 2H8.93c-1.25 0-1.9.68-1.9 1.99v1.08H5.9C4.65 5.07 4 5.75 4 7.04v9c0 1.3.65 1.96 1.89 1.96zm8.07-7.35c0-.8-.1-1.18-.58-1.7l-3.14-3.28c-.47-.49-.87-.6-1.58-.6H8.2V4.01c0-.53.26-.82.8-.82h2.95v2.94c0 .75.39 1.13 1.1 1.13h2.8V13c0 .54-.26.82-.8.82h-1.08v-3.17zm-.78-4.37c-.2 0-.28-.1-.28-.3V3.42l2.74 2.87h-2.46zM5.98 16.8c-.54 0-.82-.3-.82-.85V7.1c0-.54.28-.85.83-.85h2.46v3.25c0 .86.41 1.28 1.25 1.28h3.1v5.17c0 .55-.27.85-.83.85H6zm3.83-7.06c-.24 0-.34-.1-.34-.36V6.42l3.18 3.33H9.81z"
                        fill="#06C"/></svg>
                     <span class="copy__traking_alert">{{ get_translation_constant('text_copied_to_clipboard') }}</span>
                </span>
                    </p>
                    <p><label>{{ formatText(get_translation_constant('text_arrival_date')) }}:</label>
                        <span>{{ getParcelDate }}</span>
                    </p>
                    <p><label>{{ formatText(get_translation_constant('text_flight')) }}:</label> {{
                            getOrderFlight(parcel)
                        }}</p>
                </template>
                <template v-else-if="['delivered'].includes(ordertype)  && (parcel.location_id === 1)">
                    <div class="order__block_info">
                        <p>
                            <label>{{ formatText(get_translation_constant('text_tracking_number_full')) }}:</label> <a
                            href="javascript:void(0)" class="order__traking_number">{{ parcel.track_code }}</a><span
                            class="copy__traking_number"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                              xmlns="http://www.w3.org/2000/svg"><path
                            d="M5.89 18h6.18c1.25 0 1.9-.67 1.9-1.96V15h1.12c1.26 0 1.91-.67 1.91-1.98V7.45c0-.79-.16-1.3-.62-1.78l-2.89-3.03A2.1 2.1 0 0011.86 2H8.93c-1.25 0-1.9.68-1.9 1.99v1.08H5.9C4.65 5.07 4 5.75 4 7.04v9c0 1.3.65 1.96 1.89 1.96zm8.07-7.35c0-.8-.1-1.18-.58-1.7l-3.14-3.28c-.47-.49-.87-.6-1.58-.6H8.2V4.01c0-.53.26-.82.8-.82h2.95v2.94c0 .75.39 1.13 1.1 1.13h2.8V13c0 .54-.26.82-.8.82h-1.08v-3.17zm-.78-4.37c-.2 0-.28-.1-.28-.3V3.42l2.74 2.87h-2.46zM5.98 16.8c-.54 0-.82-.3-.82-.85V7.1c0-.54.28-.85.83-.85h2.46v3.25c0 .86.41 1.28 1.25 1.28h3.1v5.17c0 .55-.27.85-.83.85H6zm3.83-7.06c-.24 0-.34-.1-.34-.36V6.42l3.18 3.33H9.81z"
                            fill="#06C"/></svg>
                                        <span class="copy__traking_alert">{{
                                                get_translation_constant('text_copied_to_clipboard')
                                            }}</span></span>
                        </p>
                        <p><label>{{ formatText(getDateText) }}:</label> <span>{{ getParcelDate }}</span>
                        </p>
                        <p v-if="(typeof parcel.market_link !=='undefined')">
                            <label>{{ formatText(get_translation_constant('text_shop')) }}:</label>
                            <a class="order__shop_link" :href="parcel.market_link">{{ parcel.market.title }}</a>
                        </p>
                        <div class="order__print">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M6.11 17.76h.74v.82c0 .99.46 1.42 1.36 1.42h7.58c.9 0 1.36-.43 1.36-1.42v-.82h.75c1.37 0 2.1-.72 2.1-2.17V8.65c0-1.43-.73-2.17-2.1-2.17h-.7V6.1c0-1.45-.7-2.09-2-2.09H8.8c-1.23 0-2 .64-2 2.09v.4h-.69C4.8 6.48 4 7.21 4 8.64v6.94c0 1.45.73 2.17 2.11 2.17zm1.8-11.75c0-.62.3-.93.89-.93h6.4c.6 0 .9.3.9.93v.47H7.9v-.47zM6.1 16.65c-.63 0-.96-.35-.96-1V8.59c0-.65.33-1 .96-1H17.9c.62 0 .95.35.95 1v7.06c0 .65-.33 1-.95 1h-.76V12.2c0-.98-.46-1.41-1.36-1.41H8.21c-.85 0-1.36.43-1.36 1.41v4.45H6.1zm2.46 2.24c-.37 0-.57-.2-.57-.6v-5.8c0-.4.2-.58.57-.58h6.89c.38 0 .56.18.56.58v5.8c0 .4-.18.6-.56.6H8.56zm.99-4.31h4.92c.25 0 .44-.2.44-.47a.43.43 0 00-.44-.45H9.55c-.26 0-.45.2-.45.45 0 .27.2.47.45.47zm0 2.58h4.92c.25 0 .44-.2.44-.45 0-.26-.19-.46-.44-.46H9.55c-.26 0-.45.2-.45.46 0 .25.2.45.45.45z"
                                    fill="#515154"/>
                            </svg>
                        </div>
                    </div>
                    <div class="order__block_list"
                         v-if="(typeof  parcel.products !== 'undefined') && parcel.products.length">
                        <h3 class="h_text">{{ get_translation_constant('text_product_list') }}</h3>
                        <table class="table table__order_item">
                            <thead>
                            <tr>
                                <th>{{ get_translation_constant('text_nomenclature') }}</th>
                                <th>{{ get_translation_constant('text_additional_services') }}</th>
                                <th>{{ get_translation_constant('text_quantity') }}</th>
                                <th>{{ get_translation_constant('text_price') }}</th>
                                <th>{{ get_translation_constant('text_total') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(product, key) in parcel.products">
                                <td><a href="#">{{ product.name }}</a></td>
                                <td>
                                    <div
                                        class="table__extras d-flex justify-content-sm-end justify-content-lg-start align-items-center">

                            <span v-for="(service, service_index) in parcel.services"
                                  class="tooltip__block tooltip__top tooltip__block_simple">
                              <span class="tooltip__block_trigger">
                                                        <img :src="service.icon" alt="" class="service-image">
                                                    </span>
                              <span class="tooltip__block_inner">
                                                        <p>{{ service.title }}</p>
                                                    </span>
                            </span>
                                    </div>
                                </td>
                                <td><strong>{{ product.qty }} х</strong></td>
                                <td><strong>{{ product.price }} $</strong></td>
                                <td><strong>{{ (product.price * product.qty).toFixed(2) }} $</strong></td>
                            </tr>

                            </tbody>
                        </table>
                        <div class="row mb-4">
                            <div class="col-12 col-md-6">
                                <!--                        <div class="d-flex align-items-center agent__info">
                                                            {{ get_translation_constant('text_delivery_through_agent') }}
                                                            <span class="tooltip__block tooltip__bottom tooltip__modal">
                                                                        <span class="tooltip__block_trigger">
                                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                                <path
                                                                                    d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                                                                    fill="#515154"/>
                                                                            </svg>
                                                                        </span>
                                                                        <span class="tooltip__block_overlay">
                                                                                            <span class="tooltip__block_inner">
                                                                                                <span class="tooltip__block_close"></span>
                                                                                                <p>{{
                                                                                                        get_translation_constant('text_creating_agents_is_relevant')
                                                                                                    }}</p>
                                                                            <p><a href="#">{{
                                                                                    get_translation_constant('text_learn_more_about_agents')
                                                                                }}</a></p>
                                                                        </span>
                                                                        </span>
                                                                    </span>
                                                        </div>-->
                            </div>
                            <div class="col-12 col-md-6 text-md-end">
                                <div class="packages__total_price">
                                    {{ get_translation_constant('text_total_products_price') }}:
                                    <span>{{ totalProductPrice }}</span> $
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="row">
                        <div class="col-12 col-md-auto">
                            <p>
                                <label>{{ get_translation_constant('text_tracking_number_full') }}:</label>
                                <a href="#" class="order__traking_number">{{ parcel.track_code }}</a>
                                <span class="copy__traking_number">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M5.89 18h6.18c1.25 0 1.9-.67 1.9-1.96V15h1.12c1.26 0 1.91-.67 1.91-1.98V7.45c0-.79-.16-1.3-.62-1.78l-2.89-3.03A2.1 2.1 0 0011.86 2H8.93c-1.25 0-1.9.68-1.9 1.99v1.08H5.9C4.65 5.07 4 5.75 4 7.04v9c0 1.3.65 1.96 1.89 1.96zm8.07-7.35c0-.8-.1-1.18-.58-1.7l-3.14-3.28c-.47-.49-.87-.6-1.58-.6H8.2V4.01c0-.53.26-.82.8-.82h2.95v2.94c0 .75.39 1.13 1.1 1.13h2.8V13c0 .54-.26.82-.8.82h-1.08v-3.17zm-.78-4.37c-.2 0-.28-.1-.28-.3V3.42l2.74 2.87h-2.46zM5.98 16.8c-.54 0-.82-.3-.82-.85V7.1c0-.54.28-.85.83-.85h2.46v3.25c0 .86.41 1.28 1.25 1.28h3.1v5.17c0 .55-.27.85-.83.85H6zm3.83-7.06c-.24 0-.34-.1-.34-.36V6.42l3.18 3.33H9.81z"
                                        fill="#06C"></path></svg>
                                        <span class="copy__traking_alert">{{
                                                get_translation_constant('text_copied_to_clipboard')
                                            }}</span>
                            </span>
                            </p>
                            <p><label>{{ get_translation_constant('text_flight') }}:</label> {{
                                    getOrderFlight(parcel)
                                }}
                            </p>
                        </div>
                        <div class="col-12 col-md-auto pl-md-5">
                            <p><label>{{ get_translation_constant('text_arrival_date') }}:</label> <span>{{
                                    parcel.date
                                }}</span></p>
                            <p><label>{{ get_translation_constant('text_bar_code') }}:</label>
                                <a href="javascript:void(0)">{{
                                        (typeof parcel.bar_code !== 'undefined') && (typeof parcel.bar_code !== null) ? parcel.bar_code : '-'
                                    }}</a>
                            </p>
                        </div>
                    </div>
                </template>
                <div class="order__print">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.11 17.76h.74v.82c0 .99.46 1.42 1.36 1.42h7.58c.9 0 1.36-.43 1.36-1.42v-.82h.75c1.37 0 2.1-.72 2.1-2.17V8.65c0-1.43-.73-2.17-2.1-2.17h-.7V6.1c0-1.45-.7-2.09-2-2.09H8.8c-1.23 0-2 .64-2 2.09v.4h-.69C4.8 6.48 4 7.21 4 8.64v6.94c0 1.45.73 2.17 2.11 2.17zm1.8-11.75c0-.62.3-.93.89-.93h6.4c.6 0 .9.3.9.93v.47H7.9v-.47zM6.1 16.65c-.63 0-.96-.35-.96-1V8.59c0-.65.33-1 .96-1H17.9c.62 0 .95.35.95 1v7.06c0 .65-.33 1-.95 1h-.76V12.2c0-.98-.46-1.41-1.36-1.41H8.21c-.85 0-1.36.43-1.36 1.41v4.45H6.1zm2.46 2.24c-.37 0-.57-.2-.57-.6v-5.8c0-.4.2-.58.57-.58h6.89c.38 0 .56.18.56.58v5.8c0 .4-.18.6-.56.6H8.56zm.99-4.31h4.92c.25 0 .44-.2.44-.47a.43.43 0 00-.44-.45H9.55c-.26 0-.45.2-.45.45 0 .27.2.47.45.47zm0 2.58h4.92c.25 0 .44-.2.44-.45 0-.26-.19-.46-.44-.46H9.55c-.26 0-.45.2-.45.46 0 .25.2.45.45.45z"
                            fill="#515154"/>
                    </svg>
                </div>
            </div>
            <h4 class="h_text" v-if="['sent'].includes(ordertype)">{{ get_translation_constant('text_bill') }}</h4>
            <!-- if ukraine and not delivered-->
            <table v-if="!['delivered'].includes(ordertype)  && (parcel.location_id === 1)"
                   class="table table__arrived__item__orders">
                <thead>
                <tr>
                    <th>{{ get_translation_constant('text_weight') }}</th>
                    <th>{{ get_translation_constant('text_rate') }}</th>
                    <th>{{ get_translation_constant('text_additional_services') }}</th>
                    <th v-if="parcelNotPaidBill && (parcel.parcel_tracking_status_id >4)">
                        {{ get_translation_constant('text_customs_tax') }}
                    </th>
                    <th>{{ get_translation_constant('text_total') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td :data-label="get_translation_constant('text_weight')">{{
                            parcel.weight
                        }}{{ get_translation_constant('text_kg') }}
                    </td>
                    <!-- if ukraine and arrived-->
                    <template v-if="(parcel.location_id ===1) && ['arrived'].includes(ordertype)">
                        <td :data-label="get_translation_constant('text_rate')">
                            <strong>{{ parcel.tariff_to_kg }}</strong></td>
                    </template>
                    <template v-else>
                        <td :data-label="get_translation_constant('text_rate')" v-if="parcel.tariff !==null">
                            <strong>{{ parcel.tariff }}$</strong></td>
                        <td :data-label="get_translation_constant('text_rate')" v-else>-</td>
                    </template>

                    <td :data-label="get_translation_constant('text_additional_services')"
                        v-if="((parcel.services !==null) && (parcel.services.length >0)) || ((parcel.solutions !==null) && parcel.solutions.length >0) ">
                        <strong>{{ totalServicesSum }}</strong>
                        <span class="tooltip__block tooltip__bottom tooltip__modal">
                            <span class="tooltip__block_trigger">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                        fill="#515154"/>
                                </svg>
                            </span>
                            <span class="tooltip__block_overlay">
                                <span class="tooltip__block_inner tooltip__small" v-html="getServicesPrices"></span>
                            </span>
                        </span>
                    </td>
                    <td :data-label="get_translation_constant('text_additional_services')" v-else>-</td>
                    <td v-if="parcelNotPaidBill && (parcel.parcel_tracking_status_id >4)"><strong
                        :class="[billStatusClass,'customs-error']">{{ parcel.bill.amount }}$</strong>
                        <span class="tooltip__block tooltip__bottom tooltip__modal">
                            <span class="tooltip__block_trigger">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                        fill="#515154"/>
                                </svg>
                            </span>
                            <span class="tooltip__block_overlay">
                                <span class="tooltip__block_inner tooltip__small"
                                      v-html="parcelDocumentRequestData.content"></span>
                            </span>
                        </span>
                    </td>
                    <td :data-label="get_translation_constant('text_total')" v-if="parcel.total_price !==null">
                        <strong>{{ parcel.total_price }}$</strong>
                    </td>
                    <td :data-label="get_translation_constant('text_total')" v-else>-</td>
                </tr>
                </tbody>
            </table>
            <template v-if="['sent', 'arrived'].includes(ordertype)">

                <div class="d-flex align-items-center agent__info"
                     :style="!orderPaid && ['sent'].includes(ordertype)  ? '':'display: none !important;'">
                    {{ get_translation_constant('text_delivery_through_agent') }}
                    <span class="tooltip__block tooltip__bottom tooltip__modal">
                        <span class="tooltip__block_trigger">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                    fill="#515154"/>
                            </svg>
                        </span>
                        <span class="tooltip__block_overlay">
                            <span class="tooltip__block_inner">
                                <span class="tooltip__block_close"></span>
                                <p>{{ get_translation_constant('text_creating_agents_is_relevant') }}</p>
                                <p><a href="#">{{ get_translation_constant('text_learn_more_about_agents') }}</a></p>
                            </span>
                        </span>
                    </span>
                </div>
                <div
                    :class="!orderPaid && ['sent'].includes(ordertype)  ? 'd-md-flex justify-content-between align-items-center' : 'd-md-flex justify-content-end align-items-center'"
                    :style="!orderPaid? '':'display: none !important;'">
                    <div class="text__small color__red mb-3 mb-md-0"
                         :style="!orderPaid && ['sent'].includes(ordertype)  ? '':'display: none !important;'">
                        {{ get_translation_constant('text_pay_for_order') }}
                    </div>
                    <a class="btn btn__large btn__blue d-block" href="#" data-bs-toggle="modal" id="orderPaymentTrigger"
                       data-bs-target="#orderPayment">{{ get_translation_constant('text_pay') }}</a>
                </div>

                <div class="d-md-flex justify-content-еnd mt-4"
                     :style="(!!orderPaid &&  ((order.shipping_info === null) || ((order.shipping_method !== null) && (order.shipping_method.pre_save)))) ? '':'display: none !important;'">
                    <div class="d-flex align-items-center agent__info"
                         :style="['sent'].includes(ordertype)  ? '':'display: none !important;'">
                        {{ get_translation_constant('text_delivery_through_agent') }}
                        <span class="tooltip__block tooltip__bottom tooltip__modal">
                            <span class="tooltip__block_trigger">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z"
                                        fill="#515154"></path>
                                </svg>
                            </span>
                            <span class="tooltip__block_overlay">
                                <span class="tooltip__block_inner">
                                    <span class="tooltip__block_close"></span>
                                    <p>{{ get_translation_constant('text_creating_agents_is_relevant') }}</p>
                                    <p><a href="#">{{
                                            get_translation_constant('text_learn_more_about_agents')
                                        }}</a></p>
                                </span>
                            </span>
                        </span>
                    </div>
                    <a class="btn btn__large btn__green d-block" href="#" data-bs-toggle="modal"
                       id="orderDeliveryTrigger"
                       data-bs-target="#orderDelivery">{{ get_translation_constant('text_arrange_delivery') }}</a>
                </div>


<!--                <div v-if="parcelHasWaitingDocumentRequest" class="d-md-flex" :class="parcelDocumentRequestData.class">
                    {{ parcelDocumentRequestData.content }}
                </div>-->
                <!-- Verification customs -->
                <!--                <div v-if="parcelNotPaidBill"
                                     class="verification-customs customs-error"
                                >
                                    {{ 'Ваша посылка остановлена на таможенном контроле. Необходимо оплатить таможенный налог в размере' }}
                                    <strong :class="billStatusClass">{{ parcel.bill.amount }}$ </strong>
                                </div>
                                <div v-if="parcelNotPaidBill"
                                     class="verification-customs customs-review"
                                >
                                    {{ 'Ваша посылка остановлена на таможенном контроле. Необходимо оплатить таможенный налог в размере' }}
                                    <strong :class="billStatusClass">{{ parcel.bill.amount }}$ </strong>
                                </div>
                                <div v-if="parcelNotPaidBill"
                                     class="verification-customs customs-success"
                                >
                                    {{ 'Ваша посылка остановлена на таможенном контроле. Необходимо оплатить таможенный налог в размере' }}
                                    <strong :class="billStatusClass">{{ parcel.bill.amount }}$ </strong>
                                </div>-->

                <!-- Modal order Payment -->
                <div class="modal fade modal__custom" id="orderPayment" tabindex="-1" role="dialog"
                     aria-labelledby="orderPaymentTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="orderPaymentTitle">{{
                                        get_translation_constant('text_order_payment')
                                    }}</h5>
                                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                                        id="orderPaymentClose" data-bs-target="#orderPayment"></button>
                            </div>
                            <div class="modal-body">
                                <table class="table table__order_payment">
                                    <thead>
                                    <tr>
                                        <th>
                                            <p><span class="h_text">{{ get_translation_constant('text_bill') }}</span>
                                                {{ form.orders.length }}
                                                ({{ get_translation_constant('text_one_order') }})</p>
                                        </th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(form_order , key) in form.orders">
                                        <td>{{ get_translation_constant('text_order_number') }}{{ form_order.id }}</td>
                                        <td>{{ getTotalPrice(form_order) }} $</td>
                                    </tr>
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <td class="h6 color__black">{{ get_translation_constant('text_total') }}</td>
                                        <td>{{ calculatedOrdersTotalSum }}</td>
                                    </tr>
                                    </tfoot>
                                </table>

                                <form action="">
                                    <div class="row align-items-baseline">
                                        <div class="col-12 col-md-8">
                                            <div class="form__col"
                                                 :class="hasError('paymentMethod')">
                                                <multiselect v-model="form.paymentMethod"
                                                             class="form-control"
                                                             :multiple="false"
                                                             :placeholder="get_translation_constant('text_choose_method')"
                                                             :options="filteredPaymentMethods"
                                                             label="title"
                                                             selectLabel=""
                                                             deselectLabel=""
                                                             :optionHeight="48"
                                                             :showPointer="true"
                                                >
                                                    <template></template>
                                                </multiselect>
                                                <div class="form__error"
                                                     v-if="hasErrorMessage('paymentMethod' )">
                                                    <template v-if="form.paymentMethod===null">
                                                        {{ get_translation_constant('text_insufficient_funds') }}
                                                    </template>
                                                    <template v-else-if="checkFunds">
                                                        {{ get_translation_constant('text_insufficient_funds') }}
                                                    </template>
                                                    <template v-else> {{
                                                            get_translation_constant('text_field_is_required')
                                                        }}
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <div class="form__col">
                                                <input
                                                    @click.prevent="pay()"
                                                    class="btn btn__large btn__blue btn__block payment__success"
                                                    type="submit" :value="get_translation_constant('text_pay')">
                                            </div>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>

                <!-- Modal order Delivery -->
                <div class="modal fade modal__custom" id="orderDelivery" tabindex="-1" role="dialog"
                     aria-labelledby="orderDeliveryTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="orderDeliveryTitle">
                                    {{ get_translation_constant('text_arrange_delivery') }}</h5>
                                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                                        id="orderDeliveryClose" data-bs-target="#orderDelivery"></button>
                            </div>
                            <div class="modal-body">
                                <form action="">
                                    <h5 class="h_text">{{
                                            get_translation_constant('text_choose_delivery_method')
                                        }}</h5>

                                    <div class="form__col d-none d-md-block">
                                        <div class="row no-gutters radio_group__custom">
                                            <div v-for="(method, key ) in deliverymethods"
                                                 class="col-12 col-md-4 radio_group__item"
                                                 :class="getClassDeliveryUkraine"
                                            >
                                                <input :id="method.title" type="radio" @click="setDelivery(method)"
                                                       :checked="method.id=== form.deliveryMethod.id"
                                                       :value="method.id">
                                                <label :for="method.title">{{ method.title }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form__col d-md-none delivery__select">
                                        <multiselect v-model="form.deliveryMethod"
                                                     class="form-control"
                                                     :multiple="false"
                                                     :placeholder="get_translation_constant('text_choose_delivery_method')"
                                                     :options="deliveryMethodsWithDefault"
                                                     label="title"
                                                     selectLabel=""
                                                     deselectLabel=""
                                                     :optionHeight="48"
                                                     :showPointer="true"
                                        >
                                        </multiselect>
                                    </div>
                                    <template v-for="(method, key ) in deliverymethods">
                                        <!--  ukraine-->
                                        <template v-if="account.location_id === 1">
                                            <!-- pickup -->
                                            <template v-if="method.shipping_type_id === 1">

                                            </template>
                                            <!--  courier-->
                                            <template v-else-if="method.shipping_type_id === 2">
                                                <div class="delivery__address_block"
                                                     v-show="(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)">
                                                    <div class="row">
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.city', true)">
                                                                <label>{{
                                                                        get_translation_constant('text_city')
                                                                    }}<sup>*</sup></label>
                                                                <!-- kiev selected -->
                                                                <multiselect v-model="form.deliveryMethod.city"
                                                                             class="form-control"
                                                                             :multiple="false"
                                                                             :placeholder="get_translation_constant('text_choose_city')"
                                                                             :options="method.cities"
                                                                             label="title"
                                                                             selectLabel=""
                                                                             deselectLabel=""
                                                                             :optionHeight="48"
                                                                             :showPointer="true"
                                                                ></multiselect>
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.city', true)">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.address')">
                                                                <label>{{
                                                                        get_translation_constant('text_delivery_address')
                                                                    }}<sup>*</sup></label>
                                                                <input class="form__control" id="address" name="address"
                                                                       :placeholder="get_translation_constant('text_enter_address_latin_letters')"
                                                                       type="text"
                                                                       v-model="form.deliveryMethod.address">
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.address')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col" :class="hasError('agent')">
                                                                <label>{{
                                                                        get_translation_constant('text_choose_agent')
                                                                    }}</label>
                                                                <multiselect v-model="form.deliveryMethod.agent"
                                                                             class="form-control"
                                                                             :multiple="false"
                                                                             :placeholder="get_translation_constant('text_choose_agent')"
                                                                             :options="agentList"
                                                                             label="name"
                                                                             selectLabel=""
                                                                             deselectLabel=""
                                                                             :optionHeight="48"
                                                                             :showPointer="true"

                                                                >
                                                                    <template slot="singleLabel"
                                                                              slot-scope="{ option }">
                                    <span class="multiselect__single"
                                          :class="(typeof option.id !== 'undefined') && option.id === '' ? 'multiselect__placeholder__active': ''">{{
                                            (typeof option.id !== 'undefined') && option.id === '' ? get_translation_constant('text_delivery_through_agent') : option.name
                                        }}</span></template>
                                                                </multiselect>
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('agent')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('phone_prefix') || hasError('phone_number')">
                                                                <label>{{
                                                                        get_translation_constant('text_phone')
                                                                    }}</label>
                                                                <div class="phone__block">
                                                                    <multiselect v-model="form.phone_prefix"
                                                                                 class="form-control"
                                                                                 :multiple="false"
                                                                                 :placeholder="''"
                                                                                 :options="locationPrefixes"
                                                                                 label="title"
                                                                                 selectLabel=""
                                                                                 deselectLabel=""
                                                                                 :optionHeight="48"
                                                                                 :showPointer="true"
                                                                    >
                                                                        <template slot="singleLabel" slot-scope="props">
                                                                            <img class="option__image"
                                                                                 :src="props.option.image"
                                                                                 width="16">
                                                                            <span class="option__title">{{
                                                                                    props.option.title
                                                                                }}</span>
                                                                        </template>
                                                                        <template slot="option" slot-scope="props">
                                                                            <img class="option__image"
                                                                                 :src="props.option.image"
                                                                                 width="16">
                                                                            <span class="option__title">{{
                                                                                    props.option.title
                                                                                }}</span>
                                                                        </template>
                                                                    </multiselect>
                                                                    <input class="form__control type_tel"
                                                                           v-model="form.phone_number"
                                                                           type="tel">
                                                                    <div class="form__error"
                                                                         v-if="hasErrorMessage('phone_prefix') || hasError('phone_number')">
                                                                        {{
                                                                            get_translation_constant('text_field_is_required')
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!--                                                <div class="col-12">-->
                                                        <!--                                                    <p>{{ get_translation_constant('text_estimate_time') }}: <span-->
                                                        <!--                                                        class="color__black d-block d-md-inline-block">-->
                                                        <!--                                                        {{ estimateText }}-->
                                                        <!--                                                    </span>-->
                                                        <!--                                                    </p>-->
                                                        <!--                                                    <p>{{ get_translation_constant('text_delivery_price') }}: <strong-->
                                                        <!--                                                        class="color__dark_blue">{{-->
                                                        <!--                                                            (typeof form.deliveryMethod.city !== 'undefined') &&-->
                                                        <!--                                                            (form.deliveryMethod.city !== null) ? form.deliveryMethod.city.price-->
                                                        <!--                                                                : method.price-->
                                                        <!--                                                        }}</strong>-->
                                                        <!--                                                    </p>-->
                                                        <!--                                                </div>-->
                                                    </div>
                                                </div>
                                            </template>
                                            <!-- nova poshta address -->
                                            <template v-else-if="method.shipping_type_id === 3">
                                                <div class="delivery__address_block"
                                                     v-show="(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)">
                                                    <div class="row">
                                                        <div class="col-12 col-lg-6">


                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.first_name')">
                                                                <label>{{
                                                                        get_translation_constant('text_your_first_name_ukraine')
                                                                    }}<sup>*</sup></label>
                                                                <input class="form__control"
                                                                       :placeholder="get_translation_constant('text_first_name_ukraine')"
                                                                       type="text"
                                                                       v-model="form.deliveryMethod.first_name"
                                                                       ref="novaPoshtaAddressFirstName"
                                                                >
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.first_name')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.last_name')">
                                                                <label>{{
                                                                        get_translation_constant('text_your_last_name_ukraine')
                                                                    }}<sup>*</sup></label>
                                                                <input class="form__control"
                                                                       :placeholder="get_translation_constant('text_last_name_ukraine')"
                                                                       type="text"
                                                                       v-model="form.deliveryMethod.last_name"
                                                                       ref="novaPoshtaAddressLastName"
                                                                >
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.last_name')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.middle_name')">
                                                                <label>{{
                                                                        get_translation_constant('text_your_middle_name_ukraine')
                                                                    }}<sup>*</sup></label>
                                                                <input class="form__control"
                                                                       :placeholder="get_translation_constant('text_middle_name_ukraine')"
                                                                       type="text"
                                                                       v-model="form.deliveryMethod.middle_name"
                                                                       ref="novaPoshtaAddressMiddleName"
                                                                >
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.middle_name')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.text_your_city')">
                                                                <label>{{
                                                                        get_translation_constant('text_your_city')
                                                                    }}</label>
                                                                <multiselect
                                                                    v-model="form.deliveryMethod.novaPoshta.city"
                                                                    class="form-control"
                                                                    :multiple="false"
                                                                    :placeholder="get_translation_constant('text_enter_street_in_ukraine_letters')"
                                                                    :options="form.deliveryMethod.novaPoshta.cities"
                                                                    label="Description"
                                                                    selectLabel=""
                                                                    deselectLabel=""
                                                                    :optionHeight="48"
                                                                    :showPointer="true"
                                                                    @search-change="asyncCities"
                                                                    @select="loadStreetsOrWarehouses"
                                                                >
                                                                </multiselect>
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.novaPoshta.street')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.novaPoshta.street')">
                                                                <label>{{
                                                                        get_translation_constant('text_delivery_street')
                                                                    }}</label>
                                                                <multiselect
                                                                    v-model="form.deliveryMethod.novaPoshta.street"
                                                                    class="form-control"
                                                                    :multiple="false"
                                                                    :placeholder="get_translation_constant('text_enter_street_in_ukraine_letters')"
                                                                    :options="form.deliveryMethod.novaPoshta.streets"
                                                                    label="Description"
                                                                    selectLabel=""
                                                                    deselectLabel=""
                                                                    :optionHeight="48"
                                                                    :showPointer="true"
                                                                    @search-change="searchTimeOut"
                                                                >
                                                                </multiselect>
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.novaPoshta.street')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.novaPoshta.house')">
                                                                <label>{{
                                                                        get_translation_constant('text_choose_house')
                                                                    }}<sup>*</sup></label>
                                                                <input class="form__control"
                                                                       :placeholder="get_translation_constant('text_house')"
                                                                       type="text"
                                                                       v-model="form.deliveryMethod.novaPoshta.house"
                                                                >
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.novaPoshta.house')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.novaPoshta.flat')">
                                                                <label>{{
                                                                        get_translation_constant('text_choose_house')
                                                                    }}</label>
                                                                <input class="form__control"
                                                                       :placeholder="get_translation_constant('text_flat')"
                                                                       type="text"
                                                                       v-model="form.deliveryMethod.novaPoshta.flat"
                                                                >
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.novaPoshta.flat')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col" :class="hasError('agent')">
                                                                <label>{{
                                                                        get_translation_constant('text_recipient')
                                                                    }}</label>
                                                                <multiselect v-model="form.deliveryMethod.agent"
                                                                             class="form-control"
                                                                             :multiple="false"
                                                                             :placeholder="get_translation_constant('text_choose_agent')"
                                                                             :options="agentList"
                                                                             label="name"
                                                                             selectLabel=""
                                                                             deselectLabel=""
                                                                             :optionHeight="48"
                                                                             :showPointer="true"
                                                                             @select="updateNames"

                                                                >
                                                                    <template slot="singleLabel"
                                                                              slot-scope="{ option }">
                                    <span class="multiselect__single"
                                          :class="(typeof option.id !== 'undefined') && option.id === '' ? 'multiselect__placeholder__active': ''">{{
                                            (typeof option.id !== 'undefined') && option.id === '' ? get_translation_constant('text_delivery_through_agent') : option.name
                                        }}</span></template>
                                                                </multiselect>
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('agent')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('phone_prefix') || hasError('phone_number')">
                                                                <label>{{
                                                                        get_translation_constant('text_phone')
                                                                    }}</label>
                                                                <div class="phone__block">
                                                                    <multiselect v-model="form.phone_prefix"
                                                                                 class="form-control"
                                                                                 :multiple="false"
                                                                                 :placeholder="''"
                                                                                 :options="locationPrefixes"
                                                                                 label="title"
                                                                                 selectLabel=""
                                                                                 deselectLabel=""
                                                                                 :optionHeight="48"
                                                                                 :showPointer="true"
                                                                    >
                                                                        <template slot="singleLabel" slot-scope="props">
                                                                            <img class="option__image"
                                                                                 :src="props.option.image"
                                                                                 width="16">
                                                                            <span class="option__title">{{
                                                                                    props.option.title
                                                                                }}</span>
                                                                        </template>
                                                                        <template slot="option" slot-scope="props">
                                                                            <img class="option__image"
                                                                                 :src="props.option.image"
                                                                                 width="16">
                                                                            <span class="option__title">{{
                                                                                    props.option.title
                                                                                }}</span>
                                                                        </template>
                                                                    </multiselect>
                                                                    <input class="form__control type_tel"
                                                                           v-model="form.phone_number"
                                                                           type="tel">
                                                                    <div class="form__error"
                                                                         v-if="hasErrorMessage('phone_prefix') || hasError('phone_number')">
                                                                        {{
                                                                            get_translation_constant('text_field_is_required')
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <!-- nova poshta branch -->
                                            <template v-else-if="method.shipping_type_id === 4">
                                                <div class="delivery__address_block"
                                                     v-show="(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)">
                                                    <div class="row">
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.first_name')">
                                                                <label>{{
                                                                        get_translation_constant('text_your_first_name_ukraine')
                                                                    }}<sup>*</sup></label>
                                                                <input class="form__control"
                                                                       :placeholder="get_translation_constant('text_first_name_ukraine')"
                                                                       type="text"
                                                                       v-model="form.deliveryMethod.first_name"
                                                                       ref="novaPoshtaAddressFirstName"
                                                                >
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.first_name')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.last_name')">
                                                                <label>{{
                                                                        get_translation_constant('text_your_last_name_ukraine')
                                                                    }}<sup>*</sup></label>
                                                                <input class="form__control"
                                                                       :placeholder="get_translation_constant('text_last_name_ukraine')"
                                                                       type="text"
                                                                       v-model="form.deliveryMethod.last_name"
                                                                       ref="novaPoshtaAddressLastName"
                                                                >
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.last_name')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.middle_name')">
                                                                <label>{{
                                                                        get_translation_constant('text_your_middle_name_ukraine')
                                                                    }}<sup>*</sup></label>
                                                                <input class="form__control"
                                                                       :placeholder="get_translation_constant('text_middle_name_ukraine')"
                                                                       type="text"
                                                                       v-model="form.deliveryMethod.middle_name"
                                                                       ref="novaPoshtaAddressMiddleName"
                                                                >
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.middle_name')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.text_your_city')">
                                                                <label>{{
                                                                        get_translation_constant('text_your_city')
                                                                    }}</label>
                                                                <multiselect
                                                                    v-model="form.deliveryMethod.novaPoshta.city"
                                                                    class="form-control"
                                                                    :multiple="false"
                                                                    :placeholder="get_translation_constant('text_enter_street_in_ukraine_letters')"
                                                                    :options="form.deliveryMethod.novaPoshta.cities"
                                                                    label="Description"
                                                                    selectLabel=""
                                                                    deselectLabel=""
                                                                    :optionHeight="48"
                                                                    :showPointer="true"
                                                                    @search-change="asyncCities"
                                                                    @select="loadStreetsOrWarehouses"
                                                                >
                                                                </multiselect>
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.novaPoshta.street')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('deliveryMethod.novaPoshta.warehouse')">
                                                                <label>{{
                                                                        get_translation_constant('text_delivery_warehouse')
                                                                    }}</label>
                                                                <multiselect
                                                                    v-model="form.deliveryMethod.novaPoshta.warehouse"
                                                                    class="form-control"
                                                                    :multiple="false"
                                                                    :placeholder="get_translation_constant('text_enter_warehouse_in_ukraine_letters')"
                                                                    :options="warehouseList"
                                                                    label="Description"
                                                                    selectLabel=""
                                                                    deselectLabel=""
                                                                    :optionHeight="48"
                                                                    :showPointer="true"
                                                                    @search-change="searchTimeOutWarehouse"
                                                                >
                                                                </multiselect>
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('deliveryMethod.novaPoshta.warehouse')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col" :class="hasError('agent')">
                                                                <label>{{
                                                                        get_translation_constant('text_recipient')
                                                                    }}</label>
                                                                <multiselect v-model="form.deliveryMethod.agent"
                                                                             class="form-control"
                                                                             :multiple="false"
                                                                             :placeholder="get_translation_constant('text_choose_agent')"
                                                                             :options="agentList"
                                                                             label="name"
                                                                             selectLabel=""
                                                                             deselectLabel=""
                                                                             :optionHeight="48"
                                                                             :showPointer="true"
                                                                >
                                                                    <template slot="singleLabel"
                                                                              slot-scope="{ option }">
                                    <span class="multiselect__single"
                                          :class="(typeof option.id !== 'undefined') && option.id === '' ? 'multiselect__placeholder__active': ''">{{
                                            (typeof option.id !== 'undefined') && option.id === '' ? get_translation_constant('text_delivery_through_agent') : option.name
                                        }}</span>
                                                                    </template>
                                                                </multiselect>
                                                                <div class="form__error"
                                                                     v-if="hasErrorMessage('agent')">
                                                                    {{
                                                                        get_translation_constant('text_field_is_required')
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-lg-6">
                                                            <div class="form__col"
                                                                 :class="hasError('phone_prefix') || hasError('phone_number')">
                                                                <label>{{
                                                                        get_translation_constant('text_phone')
                                                                    }}</label>
                                                                <div class="phone__block">
                                                                    <multiselect v-model="form.phone_prefix"
                                                                                 class="form-control"
                                                                                 :multiple="false"
                                                                                 :placeholder="''"
                                                                                 :options="locationPrefixes"
                                                                                 label="title"
                                                                                 selectLabel=""
                                                                                 deselectLabel=""
                                                                                 :optionHeight="48"
                                                                                 :showPointer="true"
                                                                    >
                                                                        <template slot="singleLabel" slot-scope="props">
                                                                            <img class="option__image"
                                                                                 :src="props.option.image"
                                                                                 width="16">
                                                                            <span class="option__title">{{
                                                                                    props.option.title
                                                                                }}</span>
                                                                        </template>
                                                                        <template slot="option" slot-scope="props">
                                                                            <img class="option__image"
                                                                                 :src="props.option.image"
                                                                                 width="16">
                                                                            <span class="option__title">{{
                                                                                    props.option.title
                                                                                }}</span>
                                                                        </template>
                                                                    </multiselect>
                                                                    <input class="form__control type_tel"
                                                                           v-model="form.phone_number"
                                                                           type="tel">
                                                                    <div class="form__error"
                                                                         v-if="hasErrorMessage('phone_prefix') || hasError('phone_number')">
                                                                        {{
                                                                            get_translation_constant('text_field_is_required')
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                        <!--  moldova-->
                                        <template v-else-if="account.location_id === 2">

                                            <!-- pickup -->
                                            <template v-if="method.shipping_type_id === 1">

                                            </template>
                                            <!--  courier-->
                                            <template v-else-if="method.shipping_type_id === 2">

                                            </template>

                                        </template>
                                        <!--  AZERBAIJAN-->
                                        <template v-else-if="account.location_id === 3">
                                            <!-- pickup -->
                                            <template v-if="method.shipping_type_id === 1">

                                            </template>
                                            <!--  courier-->
                                            <template v-else-if="method.shipping_type_id === 2">

                                            </template>
                                        </template>
                                        <!--  BOSNIA-->
                                        <template v-else-if="account.location_id === 4">
                                            <!-- pickup -->
                                            <template v-if="method.shipping_type_id === 1">

                                            </template>
                                            <!--  courier-->
                                            <template v-else-if="method.shipping_type_id === 2">

                                            </template>
                                        </template>
                                    </template>
                                    <div class="form__col form__col_collapse">
                                        <label class="collapsed" data-bs-toggle="collapse" href="#collapseComment"
                                               role="button" aria-expanded="true" aria-controls="collapseComment">
                                            {{ get_translation_constant('text_comments') }}</label>
                                        <div class="collapse show" id="collapseComment">
                                            <div class="card card-body">
                                            <textarea rows="3" class="form__control"
                                                      v-model="form.deliveryMethod.comment"
                                                      type="text"
                                                      :placeholder="get_translation_constant('text_comment')+'...'">
                                            </textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-md-flex justify-content-end mb-4">
                                        <input type="submit" class="btn btn__large btn__green delivery__success d-block"
                                               @click.prevent="submitDelivery"
                                               :value="get_translation_constant('text_arrange_delivery')"
                                               :disabled="!deliveryValidated">
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Modal order Payment Success -->
                <alert-modal :title="modalTitle" :type="modalType" :message="modalMessage"
                             :modalId="modalId"></alert-modal>
            </template>
        </div>
<!--        <div class="simple__block" v-if="parcelHasDocumentRequest && (parcel.parcel_tracking_status_id >4)">
            <h3>{{ get_translation_constant('text_customs_payment_confirmation') }}</h3>
            <div class="form-check form-switch" v-if="parcelHasBill">
                <input checked class="form-check-input" id="acceptBill"
                       name="notification" type="checkbox" v-model="not_accept_bill">
                <label class="form-check-label"
                       for="acceptBill">{{
                        get_translation_constant('text_customs_tax_less')
                    }}</label>
            </div>
            <file-upload
                v-on:childToParent="setFiles($event, 'files')"
                :files_array="serverFiles"
                :multiple="true"
                :translations="translations"
                :ajax="false"
                :lng="lng"
                :upload_files_link="upload_files_link"
                :delete_files_link="delete_files_link"
                :additional_ajax_params="{ parcel_id: parcel.id }"
                :downloadlink="downloadlink"
                :template="'arrived'"
                ref="fileUpload"
            ></file-upload>
            <div class="form__col">
                <label for="comments">{{ get_translation_constant('text_comment') }}</label>
                <textarea
                    v-model="comment"
                    class="form__control"
                    name="comments"
                    id="comments"
                    :placeholder="get_translation_constant('text_comment')">
                </textarea>
            </div>
            <div class="d-flex justify-content-end">
                <a href="javascript:void(0)" class="btn btn__large btn__blue"
                   @click.prevent="sendConfirmation()">{{ get_translation_constant('text_send_confirmation') }}</a>
            </div>

            <div class="block-message-history">
                <div class="block-content">
                    <h4 class="h_text">{{ get_translation_constant('text_message_history') }}</h4>
                    <customs-comment v-for="(comment, key) in comments" :comment="comment" :key="key"
                                     :account="account"></customs-comment>
                </div>
            </div>
        </div>-->
        <div class="simple__block  mt-4" v-if="parcel.pictures.length">
            <file-upload
                :files_array="serverPictures"
                :multiple="true"
                :translations="translations"
                :ajax="false"
                :lng="lng"
                :upload_files_link="upload_files_link"
                :delete_files_link="delete_files_link"
                :additional_ajax_params="{ parcel_id: parcel.id }"
                :downloadlink="downloadlink"
                :template="'preview-photo'"
                ref="fileUpload"
            ></file-upload>
        </div>
    </div>
</template>
<script>
export default {
    name: "SentToDeliveredOrder",
    props: {
        translations: {
            type: [Object, Array]
        },
        orders: {
            type: [Object, Array]
        },
        paymentmethods: {
            type: [Object, Array],
            default: () => []
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        parcel: {
            type: [Object],
            default: null
        },
        deliverymethods: {
            type: [Object, Array],
            default: () => []
        },
        ordertype: {
            required: true,
            type: [String]
        },
        account: {
            type: [Object, Array],
            default: () => []
        },
        locations: {
            type: [Object, Array]
        },
        savedeliverylink: {
            type: [String]
        },
        dopaymentlink: {
            type: [String]
        },
        neworderslink: {
            type: [String]
        },
        ordersonwarehoselink: {
            type: [String]
        },
        sentorderslink: {
            type: [String]
        },
        arrivedorderslink: {
            type: [String]
        },
        deliveredorderslink: {
            type: [String]
        },
        upload_files_link: {
            type: [String]
        },
        delete_files_link: {
            type: [String],
            default: null
        },
        downloadlink: {
            type: [String],
            default: null
        },
        refusebilllink: {
            type: [Array],
            default: null
        },
        confirmorderlink: {
            type: [String],
            default: null
        },
        presavedeliverylink: {
            type: [String]
        },
        novaposhtacitysearchlink: {
            type: [String]
        },
        novaposhtastreetsearchlink: {
            type: [String]
        },
        novaposhtawarehousessearchlink: {
            type: [String]
        }
    },
    data() {
        return {
            errors: [],
            order: {},
            form: {
                paymentMethod: null,
                deliveryMethod: {
                    id: '',
                    pre_save: false,
                    comment: '',
                    first_name: this.account.location_id === 1 ? this.account.first_name : this.account.first_name_latin,
                    last_name: this.account.location_id === 1 ? this.account.last_name : this.account.last_name_latin,
                    middle_name: this.account.patronymic,
                    phone: this.account.phone_prefix + this.account.phone_number,
                    phone_prefix: this.account.phone_prefix,
                    phone_number: this.account.phone_number,
                    address: null,
                    city: null,
                    agent: null,
                    department: 'Kyiv 20',
                    novaPoshta: {
                        city: '',
                        cities: [],
                        street: '',
                        house: '',
                        flat: '',
                        branch: '',
                        streets: [],
                        warehouses: [],
                        warehouse: ''
                    },
                },
                orders: [],
                phone_prefix: this.account.phone_prefix,
                phone_number: this.account.phone_number,
                agent: null,
                comment: '',
            },
            trigger: {
                successPayment: false,
                successDelivery: false
            },
            modal: {
                type: 'success',
                title: '',
                message: '',
                id: 'SendToDelivered'
            },
            agents: [],
            locationPrefixes: [],
            not_accept_bill: null,
            files: [],
            serverFiles: [],
            serverPictures: [],
            comment: '',
            comments: []
        }
    },
    methods: {
        updateNames(selectedOption, id) {
            //if ukraine
            if (this.account.location_id === 1) {
                let agent = this.account.agents.find((item) => item.id = selectedOption.id)

                if (typeof agent !== 'undefined') {
                    this.form.deliveryMethod.first_name = agent.first_name
                    this.form.deliveryMethod.last_name = agent.last_name
                    this.form.deliveryMethod.middle_name = agent.patronymic
                }
            }

        },
        searchTimeOut(query) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
                this.searchChange = false;
            }
            this.searchChange = true;
            this.timer = setTimeout(() => {
                this.asyncFind(query)
            }, 1000);
        },
        asyncFindWarehouse(query) {
            axios.post(this.novaposhtawarehousessearchlink, {
                city_ref: this.form.deliveryMethod.novaPoshta.city.id,
                find_string: query
            }).then(response => {
                this.form.deliveryMethod.novaPoshta.warehouses = response.data
            });
        },
        searchTimeOutWarehouse(query) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
                this.searchChange = false;
            }
            this.searchChange = true;
            this.timer = setTimeout(() => {
                this.asyncFindWarehouse(query)
            }, 1000);
        },

        asyncCities(query) {
            if (query === '') {
                return;
            }
            axios.post(this.novaposhtacitysearchlink, {
                find_city: query
            }).then(response => {
                this.form.deliveryMethod.novaPoshta.cities = response.data
            });
        },
        searchCities(query) {
            if (query === '') {
                return;
            }
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
                this.searchChange = false;
            }
            this.searchChange = true;
            this.timer = setTimeout(() => {
                this.asyncCities(query)
            }, 1000);
        },

        loadStreetsOrWarehouses() {
            console.log('selected')

            setTimeout(() => {
                if (this.form.deliveryMethod.shipping_type_id === 3) {

                    console.log(this.form.deliveryMethod.novaPoshta.city);
                    axios.post(this.novaposhtastreetsearchlink, {
                        street_ref: this.form.deliveryMethod.novaPoshta.city.Ref,
                        find_street: ''
                    }).then(response => {
                        this.form.deliveryMethod.novaPoshta.streets = response.data
                    });
                }
                if (this.form.deliveryMethod.shipping_type_id === 4) {
                    console.log(this.form.deliveryMethod.novaPoshta.city);
                    axios.post(this.novaposhtawarehousessearchlink, {
                        city_ref: this.form.deliveryMethod.novaPoshta.city.Ref,
                    }).then(response => {
                        this.form.deliveryMethod.novaPoshta.warehouses = response.data
                    });
                }
            }, 500)
        },
        getTotalPrice(order) {
            if (typeof order.total_price === 'undefined' || order.total_price === null) {
                return '-'
            }
            return order.total_price.toFixed(2)
        },
        hasError(error, deep = false, level = 1) {
            if (deep) {
                if (level === 1) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined')
                        return 'has__error';
                }
                if (level === 2) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined' && typeof this.errors[split[0]][split[1]][split[2]] !== 'undefined')
                        return 'has__error';
                }
            }
            if (this.errors[error])
                return 'has__error';
        },
        hasErrorMessage(error, deep = false, level = 1) {

            if (deep) {
                if (level === 1) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined')
                        return this.errors[error][0];
                }
                if (level === 2) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined' && typeof this.errors[split[0]][split[1]][split[2]] !== 'undefined')
                        return this.errors[error][0];
                }
            }

            if (this.errors[error])
                return this.errors[error][0];
        },
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
        getOrderFlight(order) {
            return order?.flight?.title;
        },
        pay() {
            let sum = 0;
            this.form.orders.map((order) => {
                sum += order.total_price;
            })

            if (this.form.paymentMethod === null) {
                this.errors = {paymentMethod: ["error"]};
                return false
            }
            //check for balance
            if ((this.form.paymentMethod.payment_type.id === 1) && (this.account.balance < sum)) {
                return false
            }
            //check for bonus
            if ((this.form.paymentMethod.payment_type.id === 2) && (this.account.bonus < sum)) {
                return this.account.bonus < sum;
            }

            let payment = {
                parcel_id: this.parcel.id,
                paymentMethod: this.form.paymentMethod
            }
            axios.post(this.dopaymentlink, payment).then(response => {
                if (response.status === 200) {
                    //clear form
                    this.modal.title = this.get_translation_constant('text_success_add_payment_title');
                    this.modal.type = 'success';
                    this.modal.message = this.get_translation_constant('text_success_add_payment_message');
                    this.trigger.successPayment = true;
                    this.order.paid = true;
                    this.errors = [];
                    setTimeout(() => {
                        document.getElementById('orderPaymentClose').click()
                        this.form.paymentMethod = null
                    }, 200)

                    if (this.form.paymentMethod.payment_type.id === 1) {
                        //update balance
                        document.getElementById('balance').innerText = parseFloat(this.account.balance).toFixed(2) - parseFloat(sum).toFixed(2);
                    }
                    //check for bonus
                    if (this.form.paymentMethod.payment_type.id === 2) {
                        //update bonus
                        document.getElementById('bonus').innerText = parseFloat(this.account.bonus).toFixed(2) - parseFloat(sum).toFixed(2);
                    }
                    document.getElementById('orders_for_amount').innerText = parseFloat(this.account.orders_for_amount).toFixed(2) + parseFloat(sum).toFixed(2);


                    //TODO emit update balance or bonus
                }
            }).catch(error => {
                if (typeof error.response.status !== 'undefined') {
                    if (error.response.status === 422) {

                        this.errors = error.response.data.errors;
                        this.trigger.successPayment = false;
                        /* this.modal.title = 'Error Add message';
                         this.modal.type = 'error';
                         this.modal.message = 'Error Add message'
                         setTimeout(() => {
                              this.alertModal.click();
                         }, 200) */
                    }
                    if (error.response.status === 500) {

                        this.errors = error.response.data.errors;
                        this.modal.title = this.get_translation_constant('text_error_add_payment_title');
                        this.modal.type = 'error';
                        this.modal.message = this.get_translation_constant('text_error_add_payment_message');
                        this.trigger.successPayment = false;
                        setTimeout(() => {
                            document.getElementById('AlertModalBtn' + this.modal.id).click();
                        }, 200)
                    }
                }
            });
        },
        setDelivery(method) {

            this.form.deliveryMethod.id = method.id;
            this.form.deliveryMethod.title = method.title;
            this.form.deliveryMethod.pre_save = method.pre_save;
            this.form.deliveryMethod.shipping_type_id = method.shipping_type_id;
            //UKRAINE
            if (this.account.location_id === 1) {
                //pickup
                if (method.shipping_type_id === 1) {

                }
                //courier
                if (method.shipping_type_id === 2) {
                    this.form.deliveryMethod.city = method.cities[0];
                    this.form.deliveryMethod.address = this.account.address;
                    this.form.deliveryMethod.phone_number = this.account.phone_number;
                    if (method.pre_save) {

                        //if more then one order selected and paid,  no load presets
                        if (this.orders.filter((order) => (!!order.paid && !!order.checked)).length === 1) {

                            let order = this.orders.find((order) => (!!order.paid && !!order.checked && (order.shipping_method !== null)))
                            //restore presets
                            if (typeof order !== 'undefined') {
                                const data = JSON.parse(order.shipping_info)
                                this.form.deliveryMethod.city = data.deliveryMethod.city ?? null
                                this.form.deliveryMethod.phone = data.deliveryMethod.phone ?? ''
                                this.form.deliveryMethod.phone_prefix = data.deliveryMethod.phone_prefix ?? ''
                                this.form.deliveryMethod.phone_number = data.deliveryMethod.phone_number ?? ''
                                this.form.deliveryMethod.comment = order.shipping_method?.comment;
                                this.form.deliveryMethod.agent = data.deliveryMethod.agent
                            }
                        }
                    }

                }
                //nova poshta address
                if (method.shipping_type_id === 3) {
                    // this.handleNovaPoshtaRef('novaPoshtaAddressFirstName', 'first_name');
                    // this.handleNovaPoshtaRef('novaPoshtaAddressLastName', 'last_name');
                    // this.handleNovaPoshtaRef('novaPoshtaAddressMiddleName', 'middle_name');
                    if (method.pre_save) {

                        //if more then one order selected and paid,  no load presets
                        if (this.orders.filter((order) => (!!order.paid && !!order.checked)).length === 1) {

                            let order = this.orders.find((order) => (!!order.paid && !!order.checked && (order.shipping_method !== null)))
                            //restore presets
                            if (typeof order !== 'undefined') {
                                console.log(order)
                                const data = JSON.parse(order.shipping_info)
                                this.form.deliveryMethod.first_name = data.deliveryMethod.first_name ?? ''
                                this.form.deliveryMethod.middle_name = data.deliveryMethod.middle_name ?? ''
                                this.form.deliveryMethod.last_name = data.deliveryMethod.last_name ?? ''
                                this.form.deliveryMethod.novaPoshta.city = data.deliveryMethod.novaPoshta.city ?? {
                                    id: '',
                                    text: ''
                                }
                                this.form.deliveryMethod.novaPoshta.street = data.deliveryMethod.novaPoshta.street ?? ''
                                this.form.deliveryMethod.novaPoshta.house = data.deliveryMethod.novaPoshta.house ?? ''
                                this.form.deliveryMethod.novaPoshta.flat = data.deliveryMethod.novaPoshta.flat ?? ''
                                this.form.deliveryMethod.phone = data.deliveryMethod.phone ?? ''
                                this.form.deliveryMethod.phone_prefix = data.deliveryMethod.phone_prefix ?? ''
                                this.form.deliveryMethod.phone_number = data.deliveryMethod.phone_number ?? ''
                                this.form.deliveryMethod.comment = order.shipping_method?.comment;
                            }
                        }
                    }
                }
                //nova poshta department
                if (method.shipping_type_id === 4) {
                    if (method.pre_save) {

                        //if more then one order selected and paid,  no load presets
                        if (this.orders.filter((order) => (!!order.paid && !!order.checked)).length === 1) {

                            let order = this.orders.find((order) => (!!order.paid && !!order.checked && (order.shipping_method !== null)))
                            //restore presets
                            if (typeof order !== 'undefined') {
                                const data = JSON.parse(order.shipping_info)
                                this.form.deliveryMethod.first_name = data.deliveryMethod.first_name ?? ''
                                this.form.deliveryMethod.middle_name = data.deliveryMethod.middle_name ?? ''
                                this.form.deliveryMethod.last_name = data.deliveryMethod.last_name ?? ''

                                this.form.deliveryMethod.novaPoshta.city = data.deliveryMethod.novaPoshta.city ?? {
                                    id: '',
                                    text: ''
                                }
                                this.form.deliveryMethod.novaPoshta.warehouse = data.deliveryMethod.novaPoshta.warehouse ?? ''
                                this.form.deliveryMethod.phone = data.deliveryMethod.phone ?? ''
                                this.form.deliveryMethod.phone_prefix = data.deliveryMethod.phone_prefix ?? ''
                                this.form.deliveryMethod.phone_number = data.deliveryMethod.phone_number ?? ''
                                this.form.deliveryMethod.comment = order.shipping_method?.comment;
                            }
                        }
                    }
                }

            }
            //MOLDOVA
            if (this.account.location_id === 2) {
                //pickup
                if (method.shipping_type_id === 1) {

                }
                //courier
                if (method.shipping_type_id === 2) {

                }

            }
            //AZERBAIJAN
            if (this.account.location_id === 1) {
                //pickup
                if (method.shipping_type_id === 1) {

                }
                //courier
                if (method.shipping_type_id === 2) {

                }

            }
            //BOSNIA
            if (this.account.location_id === 4) {
                //pickup
                if (method.shipping_type_id === 1) {

                }
                //courier
                if (method.shipping_type_id === 2) {

                }
            }
        },
        submitDelivery() {
            let method = this.deliverymethods.find(item => item.id === this.form.deliveryMethod.id);
            if (typeof method !== 'undefined') {

                let delivery = {
                    parcel_id: [this.parcel.id],
                    agent: this.form.agent,
                    deliveryMethod: this.form.deliveryMethod,
                    phone_number: this.form.phone_number,
                    phone_prefix: this.form.phone_prefix,
                    comment: this.form.comment,
                    hasCities: method.cities.length > 0
                }

                axios.post(this.savedeliverylink, delivery).then(response => {
                    if (response.status === 200) {
                        //clear form
                        this.modal.title = this.get_translation_constant('text_success_add_delivery_title');
                        this.modal.type = 'success';
                        this.modal.message = this.get_translation_constant('text_success_add_delivery_message');
                        this.trigger.successDelivery = true;
                        this.errors = [];
                        this.form.deliveryMethod = {
                            id: '',
                            address: null,
                            city: null,
                        }
                        this.order.shipping_info = delivery;
                        setTimeout(() => {
                            document.getElementById('orderDeliveryClose').click();
                        }, 200)

                    }
                }).catch(error => {
                    if (typeof error.response.status !== 'undefined') {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            /*
                                this.modal.title = 'Error Add message';
                                this.modal.type = 'error';
                                this.modal.message = 'Error Add message'
                                setTimeout(() => {
                                     this.alertModal.click();
                                }, 200)
                            */
                        }
                        if (error.response.status === 500) {
                            this.errors = error.response.data.errors;
                            this.modal.title = this.get_translation_constant('text_error_add_delivery_title');
                            this.modal.type = 'error';
                            this.modal.message = this.get_translation_constant('text_error_add_delivery_message');
                            this.trigger.successDelivery = false;
                            document.getElementById('orderDeliveryTrigger').click();
                            setTimeout(() => {
                                document.getElementById('AlertModalBtn' + this.modal.id).click();
                            }, 200)
                        }
                    }
                });

            }
        },
        initModals() {

            const alertModal = document.getElementById('AlertModalBtn');

            const orderPaymentModal = document.getElementById('orderPayment');
            const orderShippingModal = document.getElementById('orderDelivery');
            if (orderPaymentModal !== null) {
                orderPaymentModal.addEventListener('hidden.bs.modal', () => {

                    if (this.trigger.successPayment) {
                        setTimeout(() => {

                            alertModal.click()
                        }, 500)
                        this.trigger.successPayment = false;
                    }
                    if (this.trigger.successDelivery) {
                        setTimeout(() => {

                            alertModal.click()
                        }, 500)
                        this.trigger.successDelivery = false;
                    }
                })
            }
            if (orderShippingModal !== null) {
                orderShippingModal.addEventListener('hidden.bs.modal', () => {
                    if (this.trigger.successPayment) {
                        setTimeout(() => {

                            alertModal.click()
                        }, 500)
                        this.trigger.successPayment = false;
                    }
                    if (this.trigger.successDelivery) {
                        setTimeout(() => {

                            alertModal.click()
                        }, 500)
                        this.trigger.successDelivery = false;
                    }
                })
            }

        },
        formatText(text) {

            if (typeof (text === 'undefined') || (text === '') || (text == null)) {
                return ''
            }
            let tmp = text.toLowerCase();
            return tmp.charAt(0).toUpperCase() + tmp.slice(1);
        },

        sendConfirmation() {
            let formData = new FormData();
            for (let key = 0; key < this.files.length; key++) {
                formData.append('files[' + key + ']', this.files[key]);
            }
            if (this.comment !== '') {
                formData.append('comment', this.comment)
            }
            if (this.not_accept_bill !== null) {
                formData.append('not_accept_bill', this.not_accept_bill ? 1 : 0)
            }
            formData.append('parcel_id', this.parcel.id)

            axios.post(this.confirmorderlink,
                formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                if (response.status === 200) {
                    this.serverFiles = response.data.customsFiles;
                    this.comments = [...response.data.customsComments];


                    this.files = [];
                    this.$refs.fileUpload.clearFiles();
                    this.$refs.fileUpload.setServerFiles(this.serverFiles);

                    this.modal.title = this.get_translation_constant('text_success_confirmation_title');
                    this.modal.type = 'success';
                    this.modal.message = this.get_translation_constant('text_success_confirmation_message');
                    this.trigger.successDelivery = true;
                    setTimeout(() => {
                        document.getElementById('AlertModalBtn' + this.modal.id).click();
                    }, 200)
                }

            }).catch(error => {
                console.log(error)
                //  console.log(error)
                /*
                if (error.response.status === 400) {
                    console.log(response.data)
                }
                if (error.response.status === 422) {
                    console.log(response.data)
                }
                if (error.response.status === 500) {
                    console.log(response.data)
                }

                 */
            });

        },
        setFiles(e) {
            this.files = e;
        }
    },
    computed: {
        warehouseList() {
            return this.form.deliveryMethod.novaPoshta.warehouses;
        },
        agentList() {
            if (this.account.agents.length < 1) {
                return []
            }
            let result = this.account.agents.filter((agent) => !agent.is_busy).map((agent) => {
                return {
                    id: agent.id,
                    name: agent.first_name_latin + ' ' + agent.last_name_latin
                }
            })
            return [{id: '', name: ''}, ...result]
        },
        totalProductPrice() {
            let price = 0;
            if (typeof this.parcel.products !== 'undefined') {
                this.parcel.products.map((product) => {
                    price += product.qty * product.price;
                });
            }
            return price.toFixed(2);
        },
        getDateText() {
            if (this.ordertype === 'on-warehouse') {
                return this.get_translation_constant('text_sent_date');
            }
            return this.get_translation_constant('text_date');
        },
        getClassDeliveryUkraine() {
            //check if Ukraine
            if (this.account.location_id === 1) {
                return 'delivery-ukraine'
            }
            return ''
        },
        totalServicesSum() {
            let price = 0;
            let percentCoefficient = 0;
            let extraServiceSum = 0;
            this.parcel.services.map((item) => {
                if (!!item.as_a_percentage) {
                    percentCoefficient += parseFloat(item.value);
                } else {
                    extraServiceSum += parseFloat(item.value);
                }
            })

            this.parcel.solutions.map((item) => {
                if (!!item.as_a_percentage) {
                    percentCoefficient += parseFloat(item.value);
                } else {
                    extraServiceSum += parseFloat(item.tariff);
                }
            })
            price = percentCoefficient * this.parcel.weight_price / 100 + extraServiceSum;
            return price.toFixed(2) + '$';
        },
        getServicesPrices() {
            let html = '';
            this.parcel.services.map((service) => {
                html += '<span class="line d-flex justify-content-between">';
                html += '<span class="text">' + service.title + '</span>';
                if (!!service.as_a_percentage) {
                    html += '<span class="val">' + (this.parcel.weight_price * service.value / 100).toFixed(2);
                } else {
                    html += '<span class="val">' + service.value.toFixed(2);
                }
                html += '$' + '</span>';
                html += '</span>';
            });
            this.parcel.solutions.map((solution) => {
                html += '<span class="line d-flex justify-content-between">';
                html += '<span class="text">' + solution.title + '</span>';
                if (!!solution.as_a_percentage) {
                    html += '<span class="val">' + (this.parcel.weight_price * solution.value / 100).toFixed(2);
                } else {
                    html += '<span class="val">' + parseFloat(solution.tariff).toFixed(2);
                }
                html += '$' + '</span>';
                html += '</span>';
            });
            return html;
        },
        modalTitle() {
            return this.modal.title
        },
        modalMessage() {
            return this.modal.message
        },
        modalType() {
            return this.modal.type
        },
        modalId() {
            return this.modal.id
        },
        filteredPaymentMethods() {
            return this.paymentmethods;
            /*
            return this.paymentmethods.filter((payment) => {
                //balance
                //TODO check if NaN, etc
                if (payment.payment_type.id === 1) {
                    return parseFloat(this.order.total_price) <= parseFloat(this.account.balance);
                    //bonus
                } else if (payment.payment_type.id === 2) {
                    return parseFloat(this.order.total_price) <= parseFloat(this.account.bonus);
                } else return true;
            }) */
        },
        deliveryMethodsWithDefault() {
            const delivery = [{
                id: 0,
                title: this.get_translation_constant('text_choose_delivery_method')
            }]
            return [delivery, ...this.deliverymethods]
        },
        estimateText() {
            return this.form.deliveryMethod?.city?.estimate_text;
        },
        deliveryValidated() {
            let method = this.deliverymethods.find(item => item.id === this.form.deliveryMethod.id);
            return (this.form.deliveryMethod.id !== 'undefined') &&
                (typeof method !== 'undefined') &&
                (method.cities.length === 0 ||
                    (method.cities.length > 0) &&
                    (typeof this.form.deliveryMethod.city !== 'undefined') &&
                    (this.form.deliveryMethod.city !== null) &&
                    // (this.form.agent !== null) &&
                    // (this.form.agent.id !== 0) &&
                    (this.form.deliveryMethod.address !== '')
                )
        },
        calculatedOrdersTotalSum() {
            let sum = 0;
            this.form.orders.map((order) => {
                sum += order.total_price;
            });
            return sum.toFixed(2) + ' $';

        },
        canPay() {
            let sum = 0;
            this.form.orders.map((order) => {
                sum += order.total_price;
            })
            if (sum <= this.account.balance) {
                return true
            }
            return sum <= this.account.bonus;
        },

        checkFunds() {
            let sum = 0;
            this.form.orders.map((order) => {
                sum += order.total_price;
            })
            if (this.form.paymentMethod === null) {
                return false
            }
            //check for balance
            if (this.form.paymentMethod.payment_type.id === 1) {
                return this.account.balance < sum;
            }
            //check for bonus
            if (this.form.paymentMethod.payment_type.id === 2) {
                return this.account.bonus < sum;
            }
            return false;
        },
        orderPaid() {
            return !!this.order.paid;
        },
        getParcelDate() {
            if (this.ordertype === 'sent') {
                return this.parcel.sent_date;
            }
            if (this.ordertype === 'arrived') {
                return this.parcel.arrived_date;
            }
            if (this.ordertype === 'delivered') {
                return this.parcel.arrived_date;
            }
            return this.parcel.date
        },
        parcelHasDocumentRequest() {
            return this.parcel.customs_document_request !== null;
        },
        parcelHasWaitingDocumentRequest() {
            return (this.parcel.customs_document_request !== null) && (this.parcel.customs_document_request?.status === 1);
        },
        parcelHasBill() {
            return this.parcel.bill !== null;
        },
        parcelNotPaidBill() {
            return (this.parcel.bill !== null) && (parseInt(this.parcel.bill?.status) === 1);
        },
        billStatusClass() {
            switch (this.parcel?.bill?.status) {
                //not paid
                case 1:
                    return 'red';
                //paid
                case 2:
                    return 'green';
                //rest
                default :
                    return ''
            }
        },
        parcelDocumentRequestData() {
            let className = '';
            let contentData = '';

            if ((typeof this.parcel.customs_document_request !== 'undefined') && (this.parcel.customs_document_request !== null)) {

                contentData = this.parcel.customs_document_request.template.content;

                switch (this.parcel.customs_document_request?.status) {
                    //waiting
                    case 1 :
                        className = 'verification-customs customs-error'
                        break;
                    //received
                    case 2 :
                        className = 'verification-customs customs-review'
                        break;
                    //closed
                    case 3 :
                        className = 'verification-customs customs-success'
                        break;
                }
            }
            return {
                class: className,
                content: contentData,
            }
        },

    },
    created() {
        this.order = this.parcel;
        this.form.orders.push(this.order);
        this.locationPrefixes = Object.values(this.locations.filter((location) => {
            return location.id === this.account.location_id
        })).map((location) => {
            return {
                image: location.image,
                title: location.phone_prefix
            };
        })

        this.form.phone_prefix = this.locationPrefixes[0]
        //
        this.serverFiles = this.parcel.customs_files;
        this.serverPictures = this.parcel.pictures;
        this.comments = [...this.parcel.customs_comments ?? []];

    },
    mounted() {
        this.initModals();
    },
    watch: {
        'form.paymentMethod': {
            handler(val) {
                if (val === null) {
                    this.errors = {paymentMethod: ["error"]};
                } else {
                    let sum = 0;
                    this.form.orders.map((order) => {
                        sum += parseFloat(order.total_price);
                    })
                    if ((val.payment_type.id === 1) && (this.account.balance < sum) ||
                        (val.payment_type.id === 2) && (this.account.bonus < sum)) {
                        this.errors = {paymentMethod: ["error"]};
                    } else {
                        this.errors = [];
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
.delivery-ukraine {
    width: 25%;
}
</style>
